import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

const PRODUTOS_URL = `${API_URL}/produtos/`;

export async function getProdutos(alias, page, token) {
    const produtosUrl = `${PRODUTOS_URL}${alias}?page=${page}`;
    const headers = { 'authorization': token }

    console.log(produtosUrl);
    const response = await axios.get(produtosUrl, { headers });
    return response.data;
}

export async function getProduto(id, token) {
    const produtosUrl = `${PRODUTOS_URL}id/${id}`;
    const headers = { 'authorization': token }

    console.log(produtosUrl);
    const response = await axios.get(produtosUrl, { headers });
    return response.data;
}


export async function saveProduto(id, newProduto, token) {
    const headers = { 'authorization': token };
    let response;
    // console.log('Url....');
    //  console.log(PRODUTOS_URL);
    if (id)
        response = await axios.patch(`${PRODUTOS_URL}${id}`, newProduto, { headers });
    else
        response = await axios.post(PRODUTOS_URL, newProduto, { headers });
    return response.data;
}
